import * as React from 'react';
import { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';
import Checkbox from './Checkbox';
import DownloadControls from './DownloadControls';

const checkboxStyleProps = {
    CheckboxChecked: {
        height: '1.4em',
        width: '1.4em',
        marginX: 'xs',
    },
    CheckboxUnchecked: {
        height: '1.4em',
        width: '1.4em',
        marginX: 'xs',
    },
};

@inject('dataStore')
@observer
class DocumentDropDownDownloadControls extends Component<any, any> {
    render() {
        const {
            theme,
            dataStore,
            showCheckbox,
            documentSelected,
            toggleDownload,
            document,
            count,
            showLabel = true,
        } = this.props;

        return (
            <Fragment>
                {showCheckbox && (
                    <Checkbox
                        checked={documentSelected(document.clientCode)}
                        onChange={() => toggleDownload(document)}
                        theme={{
                            ...theme,
                            ...checkboxStyleProps,
                        }}
                    />
                )}
                <DownloadControls
                    onClick={e => {
                        e.stopPropagation();
                        dataStore.downloadDocuments([document]);
                    }}
                    label={dataStore.getDocumentDisplayName(document)}
                    showLabel={showLabel}
                    count={count}
                    showCount={false}
                    flex="1 0 0%"
                    theme={{
                        ...theme,
                        ...{
                            DownloadControls:
                                theme.DocumentDropdownDownloadControls,
                            DownloadButton: {
                                color: 'inherit',
                                flex: '1 0 0%',
                                justifyContent: 'space-between',
                                hover: {
                                    color: 'inherit',
                                },
                                ...theme.DocumentDropdownDownloadButton,
                            },
                            DownloadButtonIcon:
                                theme.DocumentDropdownDownloadButtonIcon,
                        },
                    }}
                />
            </Fragment>
        );
    }
}

export default withTheme(DocumentDropDownDownloadControls) as any;



// WEBPACK FOOTER //
// ./src/Components/DocumentDropDownDownloadControls.tsx